<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="container-fluid">
  <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Spare Parts  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/igrn/index"> Manage GRN </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create GRN  </h6>

  <h6 class="custom-maintitle mb-2"><b>Create GRN</b></h6>
<div class="card ">
<div class="card-body">
  <form @submit.prevent="SaveGrn()" >

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Material Request Number </label>
            <input v-model="grn.request_po_no"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Received Date </label>
            <input type="date" v-model="grn.G_received_date"  style="font-size: small;" class="form-control" required>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks </label>
            <textarea v-model="grn.G_remarks" style="font-size: small;" class="form-control" rows="3"></textarea>
    </div>
  </div>
</div>



    <h6 class="purchitem mb-2"><b>GRN Items</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table table-striped table-sm table-hover ">
        <thead>
          <tr>
           
                <th>   
                  <div class="form-group custom-form required">
                    <label class="custom-label"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label"> Received Qty</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label"> Unit Cost Price</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label"> Total Cost Price</label>
                  </div>
                </th>
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
             
              <td>
                <input class="form-control" style="font-size: small;" placeholder="Select Product" v-model="detail[0].P_code" list="products" @input="loadProductId(0)"  required>
                    <datalist id="products" >
                       
                        <option v-for="product in products" :key="product.idProduct" >
                            {{ product.P_code }} :- {{ product.p_name }}
                        </option>
                        
                  
                    </datalist>  
                    <input v-model="detail[0].GD_idProduct" hidden  required>
              </td>
              <td><input type="number" v-model="detail[0].GD_received_qty" @input="fullPrice(0)" style="font-size: small;" class="form-control" required></td>
              <td><input type="number" v-model="detail[0].GD_unit_price" @input="fullPrice(0)" style="font-size: small;" class="form-control" required></td>
              <td><input v-model="detail[0].full_price" style="font-size: small;" class="form-control" disabled></td>
              <td class="custom-icon">  <b-icon @click="add" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
           
              <td>
                <input class="form-control" style="font-size: small;" placeholder="Select Product" v-model="detail[key].P_code" list="products" @input="loadProductId(key)"  required>
                    <datalist id="products" >
                       
                        <option v-for="product in products" :key="product.idProduct" >
                          {{ product.P_code }} :- {{ product.p_name }}
                        </option>
                        
                       
                    </datalist> 
                    <input v-model="detail[key].GD_idProduct" hidden required>
              </td>
              <td><input type="number" v-model="detail[key].GD_received_qty" @input="fullPrice(key)" style="font-size: small;" class="form-control" required></td>
              <td><input type="number" v-model="detail[key].GD_unit_price" @input="fullPrice(key)" style="font-size: small;" class="form-control" required></td>
              <td><input v-model="detail[key].full_price" style="font-size: small;" class="form-control" disabled></td>
              <td class="custom-icon"> 
                <b-icon @click="remove" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                 <b-icon @click="add" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
            
            <tr  style="border-bottom: 0px white solid;">
              <td></td>
              <th>Total</th>
              <td></td>
              <th>{{total}}</th>
              <td></td>
            </tr>



          
            
          </tbody>


        </table>
       
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn custom-btn btn-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>



</form>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        count: 0,
        total:0,
        
        grn:{},
        products:[],
        detail:[
        {GD_idProduct:''},
      ],
      


        
      }

    },
    mounted(){
 
  this.loadProduct();
    },
methods : {

  async SaveGrn() {
    
    console.log(this.grn);
    console.log(this.detail);
    try {
      const { data} = await  axios.post('/igrn/create',{userid:this.userid,cont:this.count,grn:this.grn,detail:this.detail},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.status = data.status;
       if(this.status == 200){
        this.$router.push('/igrn/index');
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

        async loadProductId(id){
                console.log("amila");
               
                try {
          const { data} = await  axios.post('/mproduct/loadid',{product:this.detail[id].P_code},{
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           this.detail[id].GD_idProduct= data.GD_idProduct; 
           
           
          
          
        } catch (error) {
          console.log(error.response);
        }
             
      },


  fullPrice(id) {
    this.detail[id].full_price = this.detail[id].GD_received_qty * this.detail[id].GD_unit_price;

    this.total = 0;
    for(let i=0; i<=this.count; i++ ){
      this.total = this.total + this.detail[i].full_price;
    }
 
    
  },
  
  async loadProduct() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/mproduct/loadprodcut',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.products = data.product;
      
    } catch (error) {
      console.log(error.response);
    }
  },

  add: function(){
            this.count++;
            this.detail.push({
              GD_idProduct:''
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              GD_idProduct:''
            },1)
            
        },


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>
.custom-btn {
  color: white; 
  border: 0px;
}
.table th {
  border-top: 0px !important;
}
  .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
.font-bold1{
        font-weight: bold !important;
      }
.font1{
        font-size: 13px !important;
     
      }
 .manage-boder{
      
     
      margin-bottom: 0px !important;
      padding-top: 15px !important;
      font-size: 11px !important;
      
      }
.custom-icon{
  width: 65px;
  
}
.custom-icon2{

}
.custom-form{
 margin-top: 5px !important;
 margin-bottom: 5px !important;
}
.custom-label{
 font-size: small !important;
  color: black !important;

  
  
}

.form-group.required label:after {
  content: "*";
  color: red;
}

.custom-breadcrumb{
  font-size: smaller !important;
}
.purchitem{
    background-color: #0270ce6b;
    padding: 5px 2px 5px 8px;
    border-radius: 3px;
}
.custom-maintitle{
    background-color: #a8a9aa;
    padding: 5px 2px 5px 8px;
    border-radius: 3px;
}
</style>